/* Elementary. A CSS workflow for mimicking element queries. [c]2014 @scottjehl, @filamentgroup. MIT license.

See http://filamentgroup.github.io/elementary/examples/ for docs

NOTE: This implementation works on elements with data attribute 'data-elementary' rather than a specific class as in docs
*/
// (function( w ){
function elementary( options ){
	
	var selector = options && options.selector || "[data-elementary]";
	var mods = document.querySelectorAll( selector );
	for( var m = 0; m < mods.length; m++ ){
		var mod = mods[ m ],
			breakpoints = window.getComputedStyle( mod, ":before" ).getPropertyValue( "content" ),
			widths = breakpoints.replace(/[^\d ]/g,"").split( " "),
			modWidth = mod.clientWidth,
			minWidths = [];

		for( var i = 0; i < widths.length; i++ ){
			if( window.parseFloat( widths[ i ] ) <= modWidth ){
				minWidths.push( widths[ i ] );
			}
		}
		mod.setAttribute( "data-minwidth", minWidths.join( " " ) );
	}
};

module.exports = elementary;

// })( this );